import Dexie, {} from 'dexie';
// Índices: a chave é sempre id; o resto são as leituras das telas (spec §4).
// `deleted` NÃO é índice: booleano não é chave válida de IndexedDB, então
// Dexie deixaria a linha de fora do índice em vez de indexá-la por false —
// filtrar lápide é trabalho de `.filter()`, não de índice.
// Isto mudou o `version(1)` depois de ele já ter rodado em máquina de
// desenvolvimento: como ainda não houve release, quem tiver o banco antigo
// precisa apagá-lo (DevTools → Application → IndexedDB → sheafyield).
export class Banco extends Dexie {
    perfil;
    pessoa;
    visita;
    estudo;
    sessao;
    mes;
    territorio;
    casa;
    fila;
    estado;
    dead_letter;
    constructor(nome) {
        super(nome);
        this.version(1).stores({
            perfil: 'id, user_id',
            pessoa: 'id, status, proxima_visita_em, casa_id',
            visita: 'id, [pessoa_id+em], [casa_id+em], em',
            estudo: 'id, pessoa_id',
            sessao: 'id, inicio, fim',
            mes: 'id, [ano+mes]',
            territorio: 'id',
            casa: 'id, [territorio_id+rua+ordem], territorio_id',
            fila: '++seq, tabela, id',
            estado: 'chave',
            dead_letter: '++seq, tabela, user_id',
        });
    }
    tabela(nome) {
        return this.table(nome);
    }
}
export function abrirBanco(nome = 'sheafyield') {
    return new Banco(nome);
}
//# sourceMappingURL=banco.js.map